import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import ContentLayout from '@/layouts/content-layout'
import TrendSoundFormView from '@/sections/trend-sounds/view/trend-sound-form-view'

export default function TrendSoundFormPage() {
  const location = useLocation()

  // Determine title based on pathname
  const title = useMemo(() => {
    if (location.pathname.includes('/trend-sounds/create')) {
      return 'เพิ่มเสียงเทรนด์'
    }
    if (location.pathname.match(/^\/trend-sounds\/[^/]+\/edit/)) {
      return 'แก้ไขเสียงเทรนด์'
    }
    return 'เสียงเทรนด์'
  }, [location.pathname])

  return (
    <ContentLayout title={title} backButton>
      <TrendSoundFormView />
    </ContentLayout>
  )
}
